import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _toConsumableArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Endpoints } from '../../../api/Constants';
import { handleQueryLoggerEvents } from '../../sagas/handleLoggerErrorEvents';
import { getAssetsPackageList } from '../assetsPackage';
import { validateJson } from '../../../utils/jsonschema/validator';
import { skipEventError } from '../../api/services/utils/validations';
import { handleActionsCommands } from '../../api/services/utils/handlerInterceptors';
import { EVENTS_ACTIONS } from '../../../screens/Events/constants/dictionary';
var endpoint = Endpoints.EVENTS_PLAYER;
export var getEventsQuery = {
  query: function query(_ref) {
    var playerId = _ref.playerId;
    return {
      url: "".concat(endpoint, "/").concat(playerId)
    };
  },
  providesTags: ['Events'],
  keepUnusedDataFor: 0,
  transformResponse: function transformResponse(response) {
    try {
      if (validateJson(endpoint, response)) return response;
    } catch (error) {
      return null;
    }
  },
  onQueryStarted: function () {
    var _onQueryStarted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2, _ref3) {
      var args, dispatch, queryFulfilled, _yield$queryFulfilled, data, assetsPackageIds, _error$error, _error$error$data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              args = _ref2.args;
              dispatch = _ref3.dispatch, queryFulfilled = _ref3.queryFulfilled;
              _context.prev = 2;
              _context.next = 5;
              return queryFulfilled;

            case 5:
              _yield$queryFulfilled = _context.sent;
              data = _yield$queryFulfilled.data;
              data.actions && handleActionsCommands(data.actions);
              assetsPackageIds = [data === null || data === void 0 ? void 0 : data.eventsFeatureState.assetsPackageId].concat(_toConsumableArray(data.eventsFeatureState.events.map(function (event) {
                return event.assetsPackageId;
              }))).filter(Boolean).join(',');
              _context.next = 11;
              return dispatch(getAssetsPackageList.initiate({
                assetsPackageIds: assetsPackageIds
              }));

            case 11:
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](2);
              !skipEventError((_error$error = _context.t0.error) === null || _error$error === void 0 ? void 0 : (_error$error$data = _error$error.data) === null || _error$error$data === void 0 ? void 0 : _error$error$data.errorType) && handleQueryLoggerEvents(_context.t0);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 13]]);
    }));

    function onQueryStarted(_x, _x2) {
      return _onQueryStarted.apply(this, arguments);
    }

    return onQueryStarted;
  }()
};

var handleUrlpostEventMutation = function handleUrlpostEventMutation(playerId, action, eventIds, tooltipType, eventId, url) {
  var _ref4;

  return _ref4 = {}, _defineProperty(_ref4, EVENTS_ACTIONS.NOTIFY_EVENT_DISPLAYED, "".concat(endpoint, "/").concat(playerId, "?actionId=").concat(action, "&eventIds=").concat(eventIds)), _defineProperty(_ref4, EVENTS_ACTIONS.NOTIFY_EVENT_TOOLTIP_DISPLAYED, "".concat(endpoint, "/").concat(playerId, "?actionId=").concat(action, "&eventId=").concat(eventId, "&tooltipType=").concat(tooltipType)), _defineProperty(_ref4, EVENTS_ACTIONS.HTTP_REQUEST, url), _ref4;
};

export var postEventsMutation = {
  query: function query(_ref5) {
    var playerId = _ref5.playerId,
        action = _ref5.action,
        eventIds = _ref5.eventIds,
        tooltipType = _ref5.tooltipType,
        eventId = _ref5.eventId,
        url = _ref5.url;
    return {
      url: handleUrlpostEventMutation(playerId, action, eventIds, tooltipType, eventId, url)[action],
      method: 'post'
    };
  },
  keepUnusedDataFor: 0
};